<template>
  <div
    class="flex w-full flex-col items-center justify-start"
  >
    <!-- Content Section -->
    <div
      class="flex flex-col w-full max-w-screen-xl items-center justify-start py-10"
    >
      <!-- Classified Ad Section -->
      <template
        v-if="
          classifiedAdPages.length >
            0 &&
          (classifiedAdPages[0]
            .featured_classified_ads
            .length > 0 ||
            classifiedAdPages[0]
              .non_featured_classified_ads
              .length > 0)
        "
      >
        <div
          class="grid grid-cols-1 md:grid-cols-4 gap-y-5 w-full items-stretch justify-center"
          v-for="classifiedAdPage in classifiedAdPages"
          :key="
            classifiedAdPage.page_number
          "
        >
          <HomeClassifiedAdCard
            style="
              min-height: 300px;
              height: auto;
            "
            v-for="featuredAd in classifiedAdPage.featured_classified_ads"
            :key="featuredAd.slug"
            :classified-ad="featuredAd"
            @click="
              gotoClassifiedAdPage(
                featuredAd
              )
            "
          />
          <HomeClassifiedAdCard
            style="
              min-height: 300px;
              height: auto;
            "
            v-for="ad in classifiedAdPage.non_featured_classified_ads"
            :key="ad.slug"
            :classified-ad="ad"
            @click="
              gotoClassifiedAdPage(ad)
            "
          />
        </div>
      </template>
      <template v-else>
        <div
          class="flex flex-col w-full items-center justify-center h-64 bg-a-neutral-dim rounded text-a-neutral-light"
        >
          <Icon name="mdi:package-variant"
            class="text-6xl"
          />
          <p class="text-lg">
            No Classified Ad Listing
            Exists at this time
          </p>
          <p class="text-base">
            Please come back in a few
            moments...we will try our
            best to have something for
            you
          </p>
        </div>
      </template>
      <div
        class="flex flex-row items-center justify-center"
      >
        <BaseButton
          margin-classes="my-8"
          text-size-class="text-base"
          primary-color-class="a-primary"
          text-color-class="a-neutral-darkest"
          v-show="nextPageLink"
          @click="
            loadClassifiedAdsFromNextPage()
          "
          :loading="showLoadingNextPage"
          loadingSize="7px"
          loadingColor="#212427"
          :showLoadingText="
            showLoadingNextPage
          "
          loadingText="Loading More Listings..."
        >
          Load More
          <Icon name="mdi:chevron-double-down"
          />
        </BaseButton>
      </div>
      <!-- Classified Ad Section Ends -->
    </div>
  </div>
</template>

<script setup lang="ts">

import {definePageMeta} from "#imports";
import type {
  MainClassifiedAdPage,
  MainClassifiedAdsData,
} from "~/types";
import type {HomeClassifiedAd} from "~/types/main";

definePageMeta({
  layout:'main-classified-home'
});

useHead({
  title: 'Classified'
})

const mainClassifiedData = ref<MainClassifiedAdsData|null>(null);
const classifiedAdPages =  ref<MainClassifiedAdPage[]>([]);
const nextPageLink = ref('');
const prevPageLink = ref('');
const showLoadingNextPage = ref(false);

mainClassifiedData.value = (await useMainClassifiedDataManager().getMainClassifiedAds()) as MainClassifiedAdsData;

classifiedAdPages.value.push(mainClassifiedData.value?.classified_ad_page as MainClassifiedAdPage);
nextPageLink.value = mainClassifiedData.value?.pagination_links.next as string;
prevPageLink.value = mainClassifiedData.value?.pagination_links.prev as string;


function gotoClassifiedAdPage(ad:HomeClassifiedAd) {
  navigateTo({
    name: "classified-slug",
    params: { slug: ad.slug },
  });
}

async function loadClassifiedAdsFromNextPage() {
  showLoadingNextPage.value = true;
  let response = await useMainClassifiedDataManager().getMainClassifiedAdsFromUrl(nextPageLink.value as string);
  if(response){
    classifiedAdPages.value.push(response.classified_ad_page as MainClassifiedAdPage);
    nextPageLink.value =
        response.pagination_links.next as string;
    prevPageLink.value =
        response.pagination_links.prev as string;
  }
  showLoadingNextPage.value = false;
}
</script>

<style>

</style>
